import { trackEvent } from "@justhome/common";
import { FathomEvent } from "@lib/constants";
import { useEffect, useRef } from "react";

export const useTrackEvent = (eventName: FathomEvent) => {
  const timeout = useRef<number>(undefined);

  useEffect(() => {
    timeout.current = window.setTimeout(() => {
      trackEvent(eventName);
    }, 500);
    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, [eventName]);
};

export default useTrackEvent;
